/**
 * Contexto extra para tickets SNAT (bridge tienda → soft_dev).
 * - deployment_env: VUE_APP_SNAT_DEPLOY_ENV (ej. debug, staging, production)
 * - Autorrelleno opcional de ambiente/componente: VUE_APP_SNAT_DEFAULT_PROJECT_ENVIRONMENT_ID,
 *   VUE_APP_SNAT_DEFAULT_INFRASTRUCTURE_ASSET_ID
 */

function readVueEnv(key) {
  return String((typeof process !== 'undefined' && process.env && process.env[key]) || '').trim();
}

/** Entorno de build/deploy del front (no confundir con ProjectEnvironment de soft_dev). */
export function getSnatDeploymentEnv() {
  const raw = readVueEnv('VUE_APP_SNAT_DEPLOY_ENV') || readVueEnv('VUE_APP_SNAT_ENV');
  if (raw) return raw.slice(0, 64);
  if (typeof process !== 'undefined' && process.env.NODE_ENV === 'production') return 'production';
  return 'development';
}

export function getSnatClientPortalUrl() {
  return readVueEnv('VUE_APP_SNAT_CLIENT_PORTAL_URL');
}

/**
 * @param {object} form — client_id, project_id, project_environment_id, infrastructure_asset_id
 * @param {Array} environments
 * @param {Array} components
 */
export function applySnatInfraEnvDefaults(form, environments, components) {
  const elist = Array.isArray(environments) ? environments : [];
  const clist = Array.isArray(components) ? components : [];
  const envId = parseInt(readVueEnv('VUE_APP_SNAT_DEFAULT_PROJECT_ENVIRONMENT_ID') || '0', 10);
  const assetId = parseInt(readVueEnv('VUE_APP_SNAT_DEFAULT_INFRASTRUCTURE_ASSET_ID') || '0', 10);
  if (!Number.isNaN(envId) && envId > 0) {
    const row = elist.find((e) => Number(e.id) === envId);
    if (row) {
      const pid = Number(row.project_id);
      if (!form.project_id || Number(form.project_id) === pid) {
        form.project_id = pid;
        form.project_environment_id = envId;
      }
    }
  }
  if (!Number.isNaN(assetId) && assetId > 0) {
    const row = clist.find((c) => Number(c.id) === assetId);
    if (row && Number(row.client_id) === Number(form.client_id)) {
      form.infrastructure_asset_id = assetId;
    }
  }
}

/**
 * @param {object} form
 * @param {Array} environments
 * @param {Array} components
 */
export function buildSnatTicketContextPayload(form, environments, components) {
  const elist = Array.isArray(environments) ? environments : [];
  const clist = Array.isArray(components) ? components : [];
  const envRow = elist.find((e) => Number(e.id) === Number(form.project_environment_id));
  const cmpRow = clist.find((c) => Number(c.id) === Number(form.infrastructure_asset_id));
  return {
    deployment_env: getSnatDeploymentEnv(),
    project_environment_label: envRow?.name ? String(envRow.name).slice(0, 255) : '',
    infrastructure_asset_label: cmpRow?.name ? String(cmpRow.name).slice(0, 255) : '',
  };
}
